import { render } from "./Modal.vue?vue&type=template&id=2ff87e4e&scoped=true&ts=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=2ff87e4e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/legacy_vue_store/legacy_vue_store/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff87e4e"]])

export default __exports__